const DEFAULT_DEV_API_BASE_URL = 'http://localhost:4000/api/v1';
const DEFAULT_PROD_API_BASE_URL = 'https://api.ludolio.com/api/v1';

export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? DEFAULT_DEV_API_BASE_URL : DEFAULT_PROD_API_BASE_URL);

// Standalone institution sign-in (SSO discovery) page. Dev port is pinned in
// dashboards/auth/vite.config.ts.
const DEFAULT_DEV_AUTH_PORTAL_URL = 'http://localhost:5176';
const DEFAULT_PROD_AUTH_PORTAL_URL = 'https://auth.ludolio.com';

export const AUTH_PORTAL_URL =
  import.meta.env.VITE_AUTH_PORTAL_URL ||
  (import.meta.env.DEV ? DEFAULT_DEV_AUTH_PORTAL_URL : DEFAULT_PROD_AUTH_PORTAL_URL);